import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function PersonalisationFormView({ properties, values, labels, onValueChange }) {
    let formFieldComponents = [];

    properties.forEach(function (property) {
        let label = property.title + (property.required ? ' *' : '');

        switch (property.type) {
            case 'choice':
                let ChoiceComponent = ComponentRegistry.get('Choice');
                formFieldComponents.push(
                    <dl key={ property.name } className="clearfix">
                        <dt><label>{ label }</label></dt>
                        <dd>
                            <ChoiceComponent choices={ property.options }
                                             expanded={ property.multiple }
                                             value={ values[property.name] }
                                             onChange={ (value) => onValueChange(property.name, value) }
                                             placeholder={ labels.select }
                            />
                        </dd>
                    </dl>
                );
                break;

            case 'text_field':
                formFieldComponents.push(
                    <dl key={ property.name } className="clearfix">
                        <dt><label>{ label }</label></dt>
                        <dd>
                            <input type="text" className="form-control" value={ values[property.name] } onChange={(evt) => { onValueChange(property.name, evt.target.value) }} />
                        </dd>
                    </dl>
                );
                break;

            case 'text_area':
                formFieldComponents.push(
                    <dl key={ property.name } className="clearfix">
                        <dt><label>{ label }</label></dt>
                        <dd>
                            <textarea className="form-control" onChange={(evt) => { onValueChange(property.name, evt.target.value) }}>{ values[property.name] }</textarea>
                        </dd>
                    </dl>
                );
                break;

            default:
                throw new Error('Unknown personalisation property type: ' + property.type);
        }
    });

    return (
        <div className="personalisation-view">
            { formFieldComponents }
        </div>
    );
}

PersonalisationFormView.propTypes = {
    properties: PropTypes.array.isRequired,
    labels: PropTypes.shape({}).isRequired,
    onValueChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Views/PersonalisationFormView.jsx